import React, {
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
  forwardRef,
} from "react";
import MolGrid from "../../../../components/molGrid/MolGrid";
import SwalAlert from "../../../../services/swalService/SwalService";
import {
  clientPlanData,
  clientPlansGridConfig,
} from "./clientPlanList.grid.config";
import { useGetClientPlanListByIdMutation } from "../../../../app/services/clientPlanAPI";
import PropTypes from "prop-types";

const ClientPlansList = forwardRef((props, ref) => {
  const molGridRef = useRef();
  const [dataSource, setDataSource] = useState([]);
  const { confirm } = SwalAlert();
  const [sortState, setSortState] = useState([]);

  const [getClientPlanListById, {
    isLoading: isGetClientPlanLoading,
    isSuccess: isGetClientPlanSuccess,
    data: clientPlanData
  }] = useGetClientPlanListByIdMutation();

  useEffect(() => {
    getClientPlanListById(props.clientID);
  }, [props.clientID]);

  useEffect(() => {
    if (isGetClientPlanSuccess && clientPlanData) {
      if (clientPlanData) {
        setDataSource(clientPlanData);
  
        if (clientPlanData.length > 0) {
          const firstItem = clientPlanData[0];
          molGridRef.current.resetSelectedRow(0)
          props?.setSelectrow?.(firstItem.planID);
          props?.setSelectPlan?.(firstItem.planName || ""); 
        }
      }
    }
  }, [isGetClientPlanSuccess, clientPlanData]);
  
  const handleSortingChange = async(sortString,col) => {
    if (!sortString) return;    
    const newSortState = sortString
        .split(',')
        .map(item => {
            const [column, directionRaw] = item.trim().split(/\s+/); 
            const direction = directionRaw?.toLowerCase() === 'desc' ? 'desc' : 'asc';
            return { column, direction };
        })
        .filter(item => item.column); 
        const filtered = newSortState.filter(item => item.column === col.fieldName);
        setSortState(newSortState);
        const orderData = await sortData(dataSource,filtered);
        setDataSource(orderData);
};

const sortData = (data, sortState) => {
      
  return [...data].sort((a, b) => {
      for (const sort of sortState) {
          const valA = a[sort.column] ?? '';
          const valB = b[sort.column] ?? '';
          const comparison = sort.direction === 'asc' 
              ? valA.toString().localeCompare(valB.toString())
              : valB.toString().localeCompare(valA.toString());
          if (comparison !== 0) return comparison;
      }
      return 0;
  });
};


  const handleEditClick = (data) => {
    props.onEdit?.(data);
  };

  const handleRowSelect = (rowData) => {
    props?.setSelectrow(rowData.planID);
    props?.setSelectPlan(rowData.planName)
  };

  const handleDeleteClick = (data) => {
    confirm(
      "Delete?",
      "Are you sure you want to delete?",
      "Delete",
      "Cancel"
    ).then((confirmed) => {
      if (confirmed) {
      }
    });
  };

  const actionHandler = {
    EDIT: handleEditClick,
    DELETE: handleDeleteClick,
  };

  useImperativeHandle(
    ref,
    () => ({
      refreshGrid: () => {
        if (molGridRef.current) {
          getClientPlanListById(props?.clientID);
        }
      },
    }),
    [ref]
  );

  return (
    <>
      <div className="client-plan-list">
        <MolGrid
          ref={molGridRef}
          configuration={clientPlansGridConfig}
          dataSource={dataSource}
          allowPagination={false}
          pagination={{
            totalCount: dataSource.length,
            pageSize: 20,
            currentPage: 1,
          }}
          onActionChange={actionHandler}
          isLoading={isGetClientPlanLoading}
          onRowSelect={handleRowSelect}
          rowDoubleClick={handleEditClick}
          onSorting={handleSortingChange}
        />
      </div>
    </>
  );
});

ClientPlansList.propTypes = {
  clientID: PropTypes.number.isRequired,
  setSelectrow: PropTypes.func,
  setSelectPlan: PropTypes.func,
  onEdit: PropTypes.func,
};

export default ClientPlansList;
